import React from 'react';
import { ListChecks, CheckCircle2, Plus } from 'lucide-react';

export function EmptyList() {
  return (
    <div className="h-full flex items-center justify-center p-8">
      <div className="flex flex-col items-center text-center">
        <div className="relative mb-6">
          {/* Main icon */}
          <div className="w-16 h-16 bg-blue-100 rounded-xl flex items-center justify-center">
            <ListChecks className="w-8 h-8 text-blue-600" />
          </div>
          {/* Decorative icons */}
          <div className="absolute -top-2 -right-2 w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center transform rotate-12">
            <Plus className="w-4 h-4 text-gray-600" />
          </div>
          <div className="absolute -bottom-2 -left-2 w-8 h-8 bg-gray-100 rounded-lg flex items-center justify-center transform -rotate-12">
            <CheckCircle2 className="w-4 h-4 text-gray-600" />
          </div>
        </div>
        <h3 className="text-xl font-semibold text-gray-900 mb-2">Your List is Empty</h3>
        <p className="text-gray-500 max-w-sm mb-2">
          Add items to your list using the input field below.
        </p>
        <p className="text-sm text-gray-400">
          Items will be displayed here in the order you add them.
        </p>
      </div>
    </div>
  );
}
